import { render, staticRenderFns } from "./DisplayOnly.vue?vue&type=template&id=4d3c2f50&scoped=true&"
import script from "./DisplayOnly.vue?vue&type=script&lang=js&"
export * from "./DisplayOnly.vue?vue&type=script&lang=js&"
import style0 from "./DisplayOnly.vue?vue&type=style&index=0&id=4d3c2f50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c2f50",
  null
  
)

export default component.exports